import { HttpParams } from "@angular/common/http";

export class ParamsHelper {

    constructor(private params : HttpParams){}

    public setParams(param: string, value: string | number | boolean | null | undefined): ParamsHelper {
        if (!param || !this.params || value === null || value === undefined || value === '') {
            return this;
        }

        this.params = this.params.set(param, value);
        return this;
    }

    public getParams() : HttpParams { 
        return this.params;
    }
}